import { useEffect, useState } from "react";
import { X, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

// Small, creative error modal shown when ?joinus= param exists but is empty
// Also handles ?redirect= param for generic redirects
export default function ReferralRedirect() {
  const [showError, setShowError] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);

      // Handle redirect parameter first (higher priority)
      if (params.has("redirect")) {
        const redirectUrl = params.get("redirect");
        if (redirectUrl) {
          setIsRedirecting(true);
          const decodedUrl = decodeURIComponent(redirectUrl);
          window.location.href = decodedUrl;
          return;
        }
      }

      // Handle joinus parameter
      // if (params.has("joinus")) {
      //   const code = (params.get("joinus") || "").trim();

      //   if (code) {
      //     setIsRedirecting(true);
      //     const target = new URL("https://ai.zapify.pro");
      //     target.searchParams.set("joinus", code);
      //     window.location.replace(target.toString());
      //   } else {
      //     setShowError(true);
      //   }
      // }
    } catch (err) {
      // ignore
    }
  }, []);

  // Show white screen while redirecting
  if (isRedirecting) {
    return (
      <div className="fixed inset-0 z-[9999] bg-white" />
    );
  }

  if (!showError) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true">
      {/* Backdrop with slight blur to match welcome-popup feel */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setShowError(false)} />

      {/* Modal */}
      <div
        className="relative w-full max-w-sm bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden animate-in fade-in zoom-in-95 duration-200"
      >
        {/* Thin gradient accent like the welcome-popup banner but minimal */}
        <div className="h-1.5 bg-[#34ABF8]" />

        {/* Close */}
        <button
          aria-label="Close"
          onClick={() => setShowError(false)}
          className="absolute top-2.5 right-2.5 z-10 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="p-4">
          <div className="flex items-start gap-3">
            {/* Icon */}
            <div
              className="shrink-0 w-9 h-9 rounded-lg bg-orange-100 flex items-center justify-center"
            >
              <AlertTriangle className="w-5 h-5 text-orange-600" />
            </div>

            <div className="flex-1">
              <h3 className="text-base font-semibold text-gray-900">Referral code invalid</h3>
              <p className="mt-1 text-sm text-gray-600">The link you used doesn't include a valid code. Please check and try again.</p>
            </div>
          </div>

          <div className="mt-4 flex justify-end">
            <Button onClick={() => setShowError(false)} className="bg-gray-900 hover:bg-gray-800">Close</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
